export enum FieldCollectionType {
  Salmonir = 'salmonir',
  Sealice = 'sealice',
  FishQuality = 'fishquality',
  Welfare = 'welfare',
}
